import { schemaConsorsNote, schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const ConsorsNotesTableDefinitionZod = z.object({
    hasNewConsorsNotes: z.boolean(),
    loanRequestId: schemaId,
    notes: z.array(schemaConsorsNote),
    subscriptionIdentifier: z.string().nullish(),
});

export type ConsorsNotesTableSchema = z.infer<typeof ConsorsNotesTableDefinitionZod>;
